import type { Organisation, OrganisationDto } from "@/models/organisation.model"
import { languageParser } from "./language.mapper"

export class OrganisationMapper {
  private static _mapSingleOrganisationToDto(
    item: Organisation | null | undefined,
  ): OrganisationDto {
    if (!item) {
      return {} as OrganisationDto
    }

    try {
      return {
        code: item.code ?? "",
        description: languageParser(item.description),
        order: typeof item.order === "number" ? item.order : 0,
      }
    }
    catch (error) {
      console.error("Error al procesar organización:", error)
      return {} as OrganisationDto
    }
  }

  static toDto(rawData: Organisation): OrganisationDto
  static toDto(rawData: Organisation[]): OrganisationDto[]
  static toDto(
    rawData: Organisation | Organisation[] | null | undefined,
  ): OrganisationDto | OrganisationDto[] {
    if (rawData === null || rawData === undefined) {
      return []
    }

    if (Array.isArray(rawData)) {
      return rawData.map(item =>
        OrganisationMapper._mapSingleOrganisationToDto(item),
      )
    }
    else {
      return OrganisationMapper._mapSingleOrganisationToDto(rawData)
    }
  }
}
